module.exports = __webpack_public_path__ + "img/Pink.6285fdd4.png";